module.exports = {
	name: 'ids',
	validation(yup, { fieldDef }) {
		const { options = {} } = fieldDef;
		let schema = yup.array();
		if (options.required) schema = schema.min(1);
		return schema;
	}
};
